// extracted by mini-css-extract-plugin
export var section = "styles-module--section--A2_DM";
export var title = "styles-module--title--1MvGX";
export var list = "styles-module--list--2oPo3";
export var listItem = "styles-module--listItem--2mu9O";
export var text = "styles-module--text--3YAjy";
export var icon = "styles-module--icon--2TKgp";
export var img = "styles-module--img--2ThQd";